import React from 'react';
import mockUsersData from '../data/mock-users.json';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SamparkChatProvider from '@samparkchat/sampark-web-chat/sampark/sampark-chat/screens/SamparkChatProvider';
import SamparkChatScreen from '@samparkchat/sampark-web-chat/sampark/sampark-chat/screens/SamparkChatsScreen';

const appId = 'AkNJwIhHbqw2qeJBOPXXLQ11hYnHMnBu';
const secretKey = 'GK3xEYRfxr3Sw46bn1UoUDrwsoqBQMHF0mqBUZCGvt1Vgob4faRZI3B';

const allUsers = mockUsersData.doctors.map((doctor) => ({
  user_id: doctor.user_id,
  user_name: doctor.user_name,
  profile_pic: doctor.profile_pic,
}));

const DoctorDashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <>
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="grid grid-cols-12 gap-8">
          <aside className="col-span-12 lg:col-span-3 xl:col-span-2">
            <div className="sticky top-6">
              <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 mb-8 whitespace-nowrap">Traveller App</h2>
              <nav className="space-y-4">
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg bg-white shadow-[0_6px_30px_rgba(13,38,61,0.06)] border border-gray-100">
                  <span className="bg-white p-2 rounded-lg shadow-sm"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M3 12h3l3 8 4-16 3 8h4" stroke="#374151" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                  <span className="text-gray-800 font-medium">Home</span>
                </button>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg bg-white shadow-[0_6px_30px_rgba(13,38,61,0.06)] border border-gray-100">
                  <span className="bg-white p-2 rounded-lg shadow-sm"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="8" stroke="#374151" strokeWidth="1.5"/></svg></span>
                  <span className="text-gray-800 font-medium">Search</span>
                </button>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg bg-white shadow-[0_6px_30px_rgba(13,38,61,0.06)] border border-gray-100">
                  <span className="bg-white p-2 rounded-lg shadow-sm"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="14" rx="2" stroke="#374151" strokeWidth="1.5"/></svg></span>
                  <span className="text-gray-800 font-medium">Reels</span>
                </button>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg bg-white shadow-[0_6px_30px_rgba(13,38,61,0.06)] border border-gray-100">
                  <span className="bg-white p-2 rounded-lg shadow-sm"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="#374151" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                  <span className="text-gray-800 font-medium">Messages</span>
                </button>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg bg-white shadow-[0_6px_30px_rgba(13,38,61,0.06)] border border-gray-100">
                  <span className="bg-white p-2 rounded-lg shadow-sm"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#374151" strokeWidth="1.5"/></svg></span>
                  <span className="text-gray-800 font-medium">More</span>
                </button>
              </nav>
            </div>
          </aside>
          <main className="col-span-12 lg:col-span-6 xl:col-span-7">
            <div className="space-y-8">
              {/* Single feed card styled like screenshot */}
              {/* Article 1 - Scenic View */}
              <article className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden transform transition-transform hover:scale-[1.01]">
                <header className="flex items-center justify-between p-4 border-b border-gray-100">
                  <div className="flex items-center space-x-3">
                    <img src={user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || '')}&background=E5E7EB&color=9CA3AF`} alt="avatar" className="w-12 h-12 rounded-full object-cover bg-gray-200" />
                    <div>
                        <p className="font-semibold text-gray-900">travellerhub</p>
                        <p className="text-sm text-gray-500">2h</p>
                    </div>
                  </div>
                  <div className="text-sm text-gray-400">...</div>
                </header>

                <div className="relative overflow-hidden h-64">
                  <img src="/assets/traveller1.jpg" alt="Scenic" className="w-full h-full object-cover transition-transform duration-700 transform hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <div className="absolute left-6 bottom-6 text-white">
                    <h3 className="text-2xl font-extrabold">SUNSET SAIL IN THE MEDITERRANEAN</h3>
                    <p className="text-sm opacity-90 mt-1">Tips for planning a perfect sunset cruise — packing, timing, and local gems...</p>
                  </div>
                </div>
              </article>

              {/* Article 2 - Hidden Hikes */}
              <article className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden transform transition-transform hover:-translate-y-1">
                <header className="flex items-center justify-between p-4 border-b border-gray-100">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-400 flex items-center justify-center text-white font-semibold">T</div>
                    <div>
                      <p className="font-semibold text-gray-900">TrailTales</p>
                      <p className="text-sm text-gray-500">5h</p>
                    </div>
                  </div>
                  <div className="text-sm text-gray-400">...</div>
                </header>

                <div className="relative overflow-hidden h-64">
                  <img src="/assets/traveller2.jpg" alt="Hike" className="w-full h-full object-cover transition-transform duration-700 transform hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
                  <div className="absolute left-6 bottom-6 text-white">
                    <h3 className="text-2xl font-extrabold">HIDDEN HIKES: THE ULTIMATE DAY TRIP</h3>
                    <p className="text-sm opacity-90 mt-1">A curated guide to short hikes with big views — routes, difficulty, and what to pack.</p>
                  </div>
                </div>
              </article>

              <div className="h-6" />
            </div>
          </main>

          {/* Right sidebar - profile & suggestions */}
          <aside className="col-span-12 lg:col-span-3 xl:col-span-3">
            <div className="sticky top-6 space-y-6">
              <div className="flex items-center justify-between bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                <div className="flex items-center space-x-3">
                  <img src={user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || '')}&background=F3F4F6&color=9CA3AF`} alt={user?.name} className="w-12 h-12 rounded-full object-cover" />
                  <div>
                    <p className="font-semibold text-gray-900">{user?.name}</p>
                  </div>
                </div>
                <button
                  onClick={async () => {
                    await logout();
                    navigate('/login');
                  }}
                  className="text-blue-600 text-sm"
                >
                  Switch
                </button>
              </div>

              <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <p className="text-sm text-gray-500 font-semibold">Suggested for you</p>
                  <button className="text-xs text-gray-400">See All</button>
                </div>
                <div className="space-y-4">
                  {mockUsersData.doctors.slice(0, 5).map((u, i) => (
                    <div key={u.id || i} className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <img src={u.avatar || u.profile_pic || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || u.user_name || 'User')}&background=E5E7EB&color=9CA3AF`} alt={u.name || u.user_name} className="w-10 h-10 rounded-full object-cover" />
                        <div>
                          <p className="font-medium text-sm">{u.name || u.user_name}</p>
                          <p className="text-xs text-gray-400">Followed by someone</p>
                        </div>
                      </div>
                      <button className="text-blue-600 text-sm">Follow</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* <div className="flex items-center justify-center">
                <div className="w-64 bg-white p-4 rounded-full border border-gray-100 shadow-[0_8px_30px_rgba(13,38,61,0.06)] flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <SamparkChatButton
                      currentUser={user!}
                      className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center text-white relative"
                    />
                    <div>
                      <p className="font-medium text-sm">Messages</p>
                      <p className="text-xs text-gray-400">Tap to open chat</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
                    <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
                    <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div> */}
            </div>
          </aside>
        </div>
      </div>
    </div>

    <SamparkChatProvider
      appId={appId}
      secretKey={secretKey}
      varientId={'8JFfUyg9D98NgMyq2UyRWMtv7Sn6iAo6'}
      userId={user.userid}
    >
      <SamparkChatScreen
        users={allUsers}
        userId={user.userid}
        userName={user.name}
      />
    </SamparkChatProvider>
    </>
  );
};

export default DoctorDashboard;